import styled from "@emotion/styled";
import { Link as RouterLink } from "react-router";

export const NavBarRightItems = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px 24px 24px;
`;

export const LogoWrapper = styled.div`
  padding-top: 16px;
`;

export const ScrollableNavItems = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 32px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const DrawerItemGroup = styled.div<{ isDisabled?: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  cursor: ${(props) => (props.isDisabled ? "default" : "pointer")};
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
`;

export const NonScrollableNavItems = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
